/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetOrganizationGatewayActivityPayload,
  GetOrganizationGatewayActivityPayload$Outbound,
  GetOrganizationGatewayActivityPayload$outboundSchema,
} from "../components/getorganizationgatewayactivitypayload.js";

export type GetOrganizationGatewayOverviewSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationGatewayOverviewRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  getOrganizationGatewayActivityPayload: GetOrganizationGatewayActivityPayload;
};

/** @internal */
export type GetOrganizationGatewayOverviewSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationGatewayOverviewSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationGatewayOverviewSecurity$Outbound,
    GetOrganizationGatewayOverviewSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationGatewayOverviewSecurityToJSON(
  getOrganizationGatewayOverviewSecurity:
    GetOrganizationGatewayOverviewSecurity,
): string {
  return JSON.stringify(
    GetOrganizationGatewayOverviewSecurity$outboundSchema.parse(
      getOrganizationGatewayOverviewSecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationGatewayOverviewRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  GetOrganizationGatewayActivityPayload:
    GetOrganizationGatewayActivityPayload$Outbound;
};

/** @internal */
export const GetOrganizationGatewayOverviewRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationGatewayOverviewRequest$Outbound,
    GetOrganizationGatewayOverviewRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      getOrganizationGatewayActivityPayload:
        GetOrganizationGatewayActivityPayload$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        getOrganizationGatewayActivityPayload:
          "GetOrganizationGatewayActivityPayload",
      });
    }),
  );

export function getOrganizationGatewayOverviewRequestToJSON(
  getOrganizationGatewayOverviewRequest: GetOrganizationGatewayOverviewRequest,
): string {
  return JSON.stringify(
    GetOrganizationGatewayOverviewRequest$outboundSchema.parse(
      getOrganizationGatewayOverviewRequest,
    ),
  );
}
